module.exports = __webpack_public_path__ + "img/一星高级大师@2x.a661a3f8.png";